module.exports = __webpack_public_path__ + "static/media/manage-network.fc8c1afe.svg";